const SUPABASE_URL        = process.env.REACT_APP_SUPABASE_URL        || "https://nqwclyzqrywyvnemrjty.supabase.co";
const SUPABASE_ANON_KEY   = process.env.REACT_APP_SUPABASE_ANON_KEY   || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5xd2NseXpxcnl3eXZuZW1yanR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxNTg5MzAsImV4cCI6MjA4ODczNDkzMH0.C7uyVGVDUSiMWTGTdC_UTvJv93oRdGK4RS4LQyc6n1A";
const RAZORPAY_KEY_ID     = process.env.REACT_APP_RAZORPAY_KEY_ID     || "rzp_live_Saha6yFlJ2OZ3w";
const GOOGLE_MAPS_KEY     = process.env.REACT_APP_GOOGLE_MAPS_KEY     || "";

export { SUPABASE_URL, SUPABASE_ANON_KEY, RAZORPAY_KEY_ID, GOOGLE_MAPS_KEY };

// ── Private-bucket file access ────────────────────────────────────────────────
// Files in a private bucket (e.g. teacher-documents) can't be opened by their
// stored `/object/public/...` URL. Exchange that URL (or a "bucket/name" path)
// for a short-lived signed URL using the caller's token, then it can be opened.
export async function signStorageUrl(fileUrl, token, expiresIn = 3600) {
  if (!fileUrl) return null;
  const m = String(fileUrl).match(/\/object\/(?:public|sign)\/([^?]+)/);
  const path = m ? m[1] : String(fileUrl).replace(/^\/+/, "").split("?")[0]; // "bucket/name"
  try {
    const res = await fetch(`${SUPABASE_URL}/storage/v1/object/sign/${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${token || SUPABASE_ANON_KEY}` },
      body: JSON.stringify({ expiresIn }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.signedURL ? `${SUPABASE_URL}/storage/v1${data.signedURL}` : null;
  } catch { return null; }
}

// Sign then open in a new tab. Use for <a onClick={...}> on private-bucket files.
export async function openSignedUrl(fileUrl, token) {
  const url = await signStorageUrl(fileUrl, token);
  if (url) window.open(url, "_blank", "noopener,noreferrer");
  else window.alert("Could not open this file — you may not have access, or it has been removed.");
}